import { service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismNumberInput } from '@mylighthouse/prism-ember';
import type { CustomEmberTableColumn } from '@mylighthouse/prism-ember/types/components/prism/table';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

type RollingReferenceRateTableColumn = CustomEmberTableColumn & {
  id: number;
  isEditing: boolean;
  onRateChange: (
    dayOfWeek: number,
    roomId: string,
    value: number | null,
  ) => void;
};

interface SettingsRecommendationsTdRollingReferenceRateSignature {
  Args: {
    column: RollingReferenceRateTableColumn;
    value: {
      formattedValue: string;
      rawValue: number | null;
      roomId: string;
    };
  };
}

export default class TdRollingReferenceRate extends Component<SettingsRecommendationsTdRollingReferenceRateSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  onValueChange = (value: number | null): void => {
    this.args.column.onRateChange(
      this.args.column.id,
      this.args.value.roomId,
      value,
    );
  };

  <template>
    {{#if @column.isEditing}}
      <PrismNumberInput
        @inlineLabel={{this.hotelAndMarketService.hotel.currencySymbol}}
        @isSmall={{true}}
        @min={{0}}
        @onValueChange={{this.onValueChange}}
        @removePadding={{true}}
        @value={{@value.rawValue}}
      />
    {{else}}
      {{@value.formattedValue}}
    {{/if}}
  </template>
}
